import { dateToString } from "../utils/Date";
import EdakkalSlot from "./EdakkalSlot";

class EdakkalDay {
    constructor(day, earlyBird, morning, afternoon, isAvailable = true) {
        this.day = day;
        this.earlyBird = earlyBird;
        this.morning = morning;
        this.afternoon = afternoon;
        this.isAvailable = isAvailable;
    }

    static fromJson(json) {
        return new EdakkalDay(
            json.day,
            EdakkalSlot.fromJson(json.earlyBird),
            EdakkalSlot.fromJson(json.morning),
            EdakkalSlot.fromJson(json.afternoon),
            json.isAvailable ?? true,
        );
    }

    toJson() {
        return {
            day: this.day,
            earlyBird: this.earlyBird.toJson(),
            morning: this.morning.toJson(),
            afternoon: this.afternoon.toJson(),
            isAvailable: this.isAvailable,
        };
    }

    static get defaultDay() {
        return new EdakkalDay(
            dateToString(new Date()),
            EdakkalSlot.defaultEarlyBird,
            EdakkalSlot.defaultMorning,
            EdakkalSlot.defaultAfternoon,
        );
    }
}


export default EdakkalDay;